import React from 'react'
import { connect, useSelector } from 'react-redux'
import withErrorBoundary from '../../decorators/withErrorBoundary'
import Figures from './Figures'
import Emoji from './Emoji'
import Cliparts from './Cliparts'
import Textures from './Textures'
import Letterings from './Letterings'
import { conditionSelector } from '../../selectors'
import productSettings from '../../services/product-settings'

const DrawControl = () => {
  const { product, side } = useSelector(conditionSelector)

  const settings = productSettings[product]
  const hideControls = settings?.permissions?.[side]?.drawControls === false

  return hideControls ? null : (
    <div className="panel-control">
      <div className="panel-control__title">Фигуры и графика</div>
      <div className="panel-control__content">
        <Figures />
        <Emoji />
        <Cliparts />
        <Textures />
        <Letterings />
      </div>
    </div>
  )
}

export default connect()(withErrorBoundary(DrawControl))
